namespace $ {

	export type $shm_wordstat_filter_state = {
		queries: string
		query_filter: $shm_wordstat_filter
		regions: string
		period_kind: string
		period_kinds: $shm_wordstat_filter
		devices: $shm_wordstat_filter
		period: $shm_wordstat_period
	}

	export class $shm_wordstat_filter_state_store extends $mol_object2 {

		dashboard_id() {
			return 'default'
		}

		arg_name() {
			return 'wordstat_filter_id'
		}

		period_all(): $shm_wordstat_period {
			return {
				from: '0001-01-01',
				to: '2999-12-31',
			}
		}

		default_devices(): $shm_wordstat_filter {
			return {
				DEVICE_ALL: true,
				DEVICE_DESKTOP: false,
				DEVICE_PHONE: false,
				DEVICE_TABLET: false,
			}
		}

		default_period_kinds(): $shm_wordstat_filter {
			return {
				PERIOD_DAILY: false,
				PERIOD_WEEKLY: false,
				PERIOD_MONTHLY: true,
			}
		}

		defaults(): $shm_wordstat_filter_state {
			return {
				queries: '',
				query_filter: {},
				regions: 'Все',
				period_kind: 'PERIOD_MONTHLY',
				period_kinds: this.default_period_kinds(),
				devices: this.default_devices(),
				period: this.period_all(),
			}
		}

		key( id: string ) {
			return `hitalama_wordstat_filter:${ this.dashboard_id() }:${ id }`
		}

		last_id_key() {
			return `hitalama_wordstat_filter_last:${ this.dashboard_id() }`
		}

		last_id( next?: string | null ) {
			return $mol_state_local.value< string >( this.last_id_key(), next ) ?? ''
		}

		state( id: string, next?: $shm_wordstat_filter_state | null ) {
			return $mol_state_local.value< $shm_wordstat_filter_state >( this.key( id ), next )
		}

		id( next?: string | null ) {
			const arg_name = this.arg_name()
			if( !arg_name ) {
				if( next !== undefined ) return next || ''
				return this.last_id()
			}

			if( next !== undefined ) {
				$mol_state_arg.value( arg_name, next || null )
				return next || ''
			}

			const arg = $mol_state_arg.value( arg_name )
			if( arg ) return arg

			const last = this.last_id()
			if( last ) $mol_state_arg.value( arg_name, last )
			return last
		}

		current() {
			const id = this.id()
			return ( id ? this.state( id ) : null ) ?? this.defaults()
		}

		save( patch: Partial< $shm_wordstat_filter_state > ) {
			const id = $mol_guid()
			const state = {
				... this.current(),
				... patch,
			}
			this.state( id, state )
			this.last_id( id )
			this.id( id )
			if( this.arg_name() ) $mol_state_arg.commit()
			return state
		}

		queries( next?: string ) {
			if( next === undefined ) return this.current().queries
			this.save({ queries: next })
			return next
		}

		query_filter( next?: $shm_wordstat_filter ) {
			if( next === undefined ) return this.current().query_filter
			this.save({ query_filter: next })
			return next
		}

		regions( next?: string ) {
			if( next === undefined ) return this.current().regions
			this.save({ regions: next })
			return next
		}

		period_kind( next?: string ) {
			if( next === undefined ) {
				const selected = Object.entries( this.period_kinds() ).find( ( [ , checked ] )=> checked )
				return selected?.[0] ?? this.current().period_kind ?? 'PERIOD_MONTHLY'
			}

			this.save({
				period_kind: next,
				period_kinds: {
					PERIOD_DAILY: next === 'PERIOD_DAILY',
					PERIOD_WEEKLY: next === 'PERIOD_WEEKLY',
					PERIOD_MONTHLY: next === 'PERIOD_MONTHLY',
				},
			})
			return next
		}

		period_kind_period( period_kind: string, period: $shm_wordstat_period ) {
			this.save({
				period_kind,
				period_kinds: {
					PERIOD_DAILY: period_kind === 'PERIOD_DAILY',
					PERIOD_WEEKLY: period_kind === 'PERIOD_WEEKLY',
					PERIOD_MONTHLY: period_kind === 'PERIOD_MONTHLY',
				},
				period,
			})
			return period_kind
		}

		period_kinds( next?: $shm_wordstat_filter ) {
			if( next === undefined ) return this.current().period_kinds
			this.save({ period_kinds: next })
			return next
		}

		devices( next?: $shm_wordstat_filter ) {
			if( next === undefined ) return this.current().devices
			this.save({ devices: next })
			return next
		}

		period( next?: $shm_wordstat_period ) {
			if( next === undefined ) {
				const period = this.current().period
				const all = this.period_all()
				let from = period.from
				let to = period.to
				if( all.from && from < all.from ) from = all.from
				if( all.to && to > all.to ) to = all.to
				if( from > to ) return all
				return { from, to }
			}
			this.save({ period: next })
			return next
		}

		reset() {
			return this.save({
				... this.defaults(),
				period: this.period_all(),
			})
		}

	}

}
